var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEyeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#1B49EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66406 15.9994C7.66406 15.9994 10.1641 10.166 15.9974 10.166C21.8307 10.166 24.3307 15.9994 24.3307 15.9994C24.3307 15.9994 21.8307 21.8327 15.9974 21.8327C10.1641 21.8327 7.66406 15.9994 7.66406 15.9994Z",
    stroke: "#1B49EA",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.5C17.3807 18.5 18.5 17.3807 18.5 16C18.5 14.6193 17.3807 13.5 16 13.5C14.6193 13.5 13.5 14.6193 13.5 16C13.5 17.3807 14.6193 18.5 16 18.5Z",
    stroke: "#1B49EA",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeWhite);
export default __webpack_public_path__ + "static/media/eyeWhite.30abbaa1440f73b41d9e811e13d474f3.svg";
export { ForwardRef as ReactComponent };